export default {
  setCarBrand(state, data) {
    state.carBrand = data;
  },
  setCarModel(state, data) {
    state.carModel = data;
  },

  setProvince(state, data) {
    state.province = data;
  },

  setCity(state, data) {
    state.city = data;
  },

  setServices(state, data) {
    state.services = data;
  },

  setCustomerBanners(state, data) {
    state.customerBanners = data;
  },

  setBlogHome(state, data) {
    state.blogHome = data;
  },

  setSocials(state, data) {
    state.socials = data;
  },

  setProducts(state, data) {
    state.products = data;
  },

  setProductsListPage(state, data) {
    state.productsListPage = data;
  },

  setCategory(state, data) {
    state.category = data;
  },

  setRingFeature(state, data) {
    state.ringFeature = data;
  },
  setWideFeature(state, data) {
    state.wideFeature = data;
  },
  setRatioFeature(state, data) {
    state.ratioFeature = data;
  },

  setProductDetail(state, data) {
    state.productDetail = data;
  },

  setSimilarProducts(state, data) {
    state.similarProducts = data;
  },

  setTabOneProducts(state, data) {
    state.tabOneProducts = data;
  },
  setTabTwoProducts(state, data) {
    state.tabTwoProducts = data;
  },
  setTabThreeProducts(state, data) {
    state.tabThreeProducts = data;
  },

  setDynamicPageContent(state, data) {
    state.dynamicPageContent = data;
  },

  setTicketCategory(state, data) {
    state.ticketCategory = data;
  },

  setBlogs(state, data) {
    state.blogs = data;
  },
  setBlog(state, data) {
    state.blog = data;
  },
  setRelatedBlogs(state, data) {
    state.relatedBlogs = data;
  },

  setService(state, data) {
    state.service = data;
  },

  setFaq(state, data) {
    state.faq = data;
  },
  setComments(state, data) {
    state.comments = data;
  },

  setNewsLetters(state, data) {
    state.newsLetters = data;
  },
  setSlides(state, data) {
    state.slides = data;
  },

  setTeam(state, data) {
    state.team = data;
  },

  setPoster1(state, data) {
    state.poster1 = data;
  },
  setPoster2(state, data) {
    state.poster2 = data;
  },
  setPosterBlogs(state, data) {
    state.posterBlogs = data;
  },
  setPosterProducts(state, data) {
    state.posterProducts = data;
  },
  setRules(state, data) {
    state.rules = data;
  },
  setContactUs(state, data) {
    state.contactUs = data;
  },
  setFAQpage(state, data) {
    state.faqPage = data;
  },
  setAboutUs(state, data) {
    state.aboutUs = data;
  },

  setBrands(state, data) {
    state.brands = data;
  },
};
